import { React, useCallback, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import defaultProfileBg from '../../../../../assets/images/default_profile_bg.svg';
import Notification from '../../../../../components/Notification/Notification';
import Button from '../../../../../components/shared/Button/Button';
import { MAX_IMAGE_SIZE } from '../../../../../constants/commonConstants';

import styles from './AddBackgroundImageModal.module.scss';

export const AddBackgroundImageModal = ({
  showModal,
  setShowModal,
  deleteCoverPicture,
  currentUser,
  updateProfilePicture,
}) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [bgImage, setBgImage] = useState();
  const [bgImageURL, setBgImageURL] = useState(currentUser.cover_image || defaultProfileBg);

  const handleFileUpload = useCallback(
    (event) => {
      if (event.target.files && event.target.files[0]) {
        if (event.target.files[0].size > MAX_IMAGE_SIZE) {
          Notification.error(t('validation.fileSizeExceeds'));
          return;
        }
        setBgImage(event.target.files);
        setBgImageURL(URL.createObjectURL(event.target.files[0]));
      }
    },
    [setBgImage, setBgImageURL]
  );

  const deleteFileUpload = useCallback(() => {
    setBgImageURL(defaultProfileBg);
    setShowModal(false);
    setBgImage();
    dispatch(deleteCoverPicture(currentUser.cover_image_id));
  }, [defaultProfileBg, currentUser]);

  const submitFileUpload = useCallback(() => {
    if (bgImage) {
      dispatch(updateProfilePicture(bgImage, 'user_cover_image', currentUser.id));
      setBgImage();
      setShowModal(false);
    }
  }, [bgImage, currentUser.id]);

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      className={`${styles.Modal}`}
    >
      <Modal.Header className={styles.modalHeader} closeButton>
        <Modal.Title className={styles.modalTitle}>{t('backgroundPhoto.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img src={bgImageURL} className={styles.bgImage} alt="profile-bg" />
        {bgImageURL && (
          <span className={styles.uploadImageButton}>
            {t('backgroundPhoto.uploadPhoto')}
            <input type="file" accept="image/*" onChange={handleFileUpload} />
          </span>
        )}
      </Modal.Body>
      <Modal.Footer className={`text-center ${styles.footer}`}>
        <div className="col-4 m-0">
          <span className={styles.changeImageButton}>
            <input type="file" accept="image/*" onChange={handleFileUpload} />
            <Button variant="secondary" as="label" type={null} className={styles.footerButton}>
              {t('backgroundPhoto.changePhoto')}
            </Button>
          </span>
        </div>
        <div className="col-4">
          <Button
            variant="secondary"
            disabled={!currentUser.cover_image}
            className={styles.footerButton}
            onClick={deleteFileUpload}
          >
            {t('backgroundPhoto.deletePhoto')}
          </Button>
        </div>
        <div className="col-4">
          <Button variant="primary" disabled={!bgImage} className={styles.footerButton} onClick={submitFileUpload}>
            {t('apply')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
